import { Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { VhEventMediator, VhQueryAutoWeb } from 'vhautowebdb';
import { HttpClient } from '@angular/common/http';
import { forkJoin } from 'rxjs';
import { FunctionService } from 'vhobjects-service/src/services';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID, Inject } from '@angular/core';

@Component({
  selector: 'atw-text-config',
  templateUrl: './text-config.component.html',
  styleUrls: ['./text-config.component.scss']
})

export class AtwTextConfig implements OnInit, OnChanges {
  @Input() objectChoosing: any; //nhận data từ ndcDynamicInputs truyền về
  @Input() device: any; // xác định trang ở thiết bị desktop hay mobile
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_portrait_class từ database
  @Input() config: any; // là dữ liệu desktop_config hoặc mobile_portrait_config từ database
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  @Input() type: any; // xem đang ở page hay admin

  formulaDraft: any = '';
  inputCalculateCustom: any = '';
  @ViewChild('formulaBox') formulaBox!: ElementRef;
  isViewAll: boolean = false; // biến flag để hiện thị phần mở rộng cấu hình
  currentViewAll: any = {};
  isCollapsed: boolean = false;
  styles_field = [
    {
      title: 'cau_hinh_hieu_ung',
      index: 1,
    },
    {
      title: 'cau_hinh_bo_goc',
      index: 2,
    }
  ];

  customize = [];
  effect_hover = [];
  effect_hover_data: any = {};
  text_style: any = [
    {
      title: 'tieu_de_1',
      fontSize: '68px',
      name: 'h1',
      font: 21
    },
    {
      title: 'tieu_de_2',
      fontSize: '48px',
      name: 'h2',
      font: 19
    },
    {
      title: 'tieu_de_3',
      fontSize: '36px',
      name: 'h3',
      font: 18
    },
    {
      title: 'tieu_de_4',
      fontSize: '26px',
      name: 'h4',
      font: 17
    },
    {
      title: 'tieu_de_5',
      fontSize: '20px',
      name: 'h5',
      font: 16
    },
    {
      title: 'tieu_de_6',
      fontSize: '18px',
      name: 'h6',
      font: 15
    },
    {
      title: 'van_ban',
      fontSize: '18px',
      name: 'p',
      font: 14
    },
    {
      title: 'van_ban_quan_trong',
      fontSize: '18px',
      name: 'strong',
      font: 14
    },
    {
      title: 'van_ban_nho',
      fontSize: '16px',
      name: 'small',
      font: 13
    },
    {
      title: 'trich_dan',
      fontSize: '18px',
      name: 'Blockquote',
      font: 14
    }
  ];
  /** Danh sách giải thích loại văn bản tương ứng SEO */
  seoTextTypes: any = [
    { tag: 'tieu_de_1', explain: 'dung_cho_tieu_de_chinh', usage: 'chi_dung_mot_lan_trong_trang' },
    { tag: 'tieu_de_2_den_tieu_de_6', explain: 'dung_cho_cac_tieu_de_phu', usage: 'dung_theo_thu_tu_phan_cap_khong_bo_bac' },
    { tag: 'van_ban', explain: 'dung_cho_van_ban' },
    { tag: 'van_ban_quan_trong', explain: 'dung_cho_van_ban', usage: 'chi_de_nhan_y_quan_trong_dung_tiet_che' },
  ];

  id_subproject: any = "";
  subProject: any = {};

  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private http: HttpClient,
    private vhEventMediator: VhEventMediator,
    public  functionService: FunctionService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) { }

  ngOnInit(): void {
    this.getObjectForCalculate();
    this.subProject = this.vhQueryAutoWeb.getlocalSubProject(
      this.vhQueryAutoWeb.getlocalSubProject_Working()._id
    );
    // phần này get dữ liệu json
    forkJoin([
      this.http.get('assets/data/effects/text.json'),
    ]).subscribe(([effects]: any) => {
      this.effect_hover = effects;
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type']);
    });
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (this.effect_hover) {
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type']);
      this.customize = this.effect_hover_data?.data?.find(e => e.id == this.config['animation-selected']?.id)?.customize || [];
    }
    if (!this.staticdata.is_scroll) {
      this.staticdata.is_scroll = false;
    }
    if (!this.config.hasOwnProperty('is_copyright')) {
      this.config.is_copyright = false;
    }
    if (changes['objectChoosing'] && this.objectChoosing?.component === 'AtwTextCalculateCustom') {
      this.getObjectForCalculate();
    }
  }


  ngOnDestroy() {
  }

  /**
   * Cập nhật transform
   */
  handleSetTextRotate() {
    this.class['text__content']['transform'] = `rotate(${this.config['transform']['rotate']}deg)`;
  }


  /**
   * Cập nhật các thuộc tính border-radius
   */
  handleSetBorderRadius() {
    this.class['text__wrapper']['border-top-left-radius'] = this.class['text__wrapper']['border-radius'];
    this.class['text__wrapper']['border-top-right-radius'] = this.class['text__wrapper']['border-radius'];
    this.class['text__wrapper']['border-bottom-left-radius'] = this.class['text__wrapper']['border-radius'];
    this.class['text__wrapper']['border-bottom-right-radius'] = this.class['text__wrapper']['border-radius'];
    this.updateClass();
  }

  /**
   * Cập nhật Kiểu văn bản
   */
  handleSetTextStyle(action) {
    this.class['text__content']['font-size'] = this.text_style.find(style => style.name === action)['fontSize'];
    switch (action) {
      case "Blockquote":
        this.class['text__content']['border-left-width'] = '10px';
        this.class['text__content']['padding-left'] = '10px';
        break;
      default:
        this.class['text__content']['border-left-width'] = '0';
        this.class['text__content']['padding-left'] = '0';
    }

    this.handleSetCurveText();

    this.updateObject();
  }

  /**
   * Cập nhật Kiểu danh sách đầu dòng, đánh số
   */
  handleListStyle(style: string) {
    if (`${style} inside none` === this.class['text__content--list-style']['list-style']) {
      style = "none";
      this.config['text_type'] = 'p';
    }
    else {
      this.config['text_type'] = 'ul';
    }

    switch (style) {
      case 'disc':
      case 'decimal':
      case 'upper-alpha':
      case 'upper-roman':
        this.class['text__content']['flex-direction'] = 'column';
        this.class['text__content--list-style']['list-style'] = `${style} inside none`;
        break;
      default:
        this.class['text__content']['flex-direction'] = 'row';
        this.class['text__content--list-style']['list-style'] = 'none';
    }

    this.updateObject();
  }

  /**
   * hàm này để xử lý thay đổi cấu hình của  hay là StaticData
   * nếu this.objectChoosing.dynamic_data = true thì cập nhật vào
   * ngược lại cập nhật vào staticData
   */
  handleChangeConfig() {
    this.updateStaticData();
  }


  /**
  * Cập nhật staticdata vào database.
  */
  updateStaticData() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { staticdata: this.staticdata })
      .then((bool) => {
      });
  }




  /**
   * Xử lý kiểu Uốn cong
   */
  handleSetCurveText() {
    var radius = this.config['curve']['radius'] * 1;

    this.class['text__curve-item']['background-image'] = this.class['text__content']['background-image'];
    this.class['text__curve-item']['-webkit-text-fill-color'] = this.class['text__content']['-webkit-text-fill-color'];
    this.class['text__curve-item']['-webkit-background-clip'] = this.class['text__content']['-webkit-background-clip'];
    // this.class['text__curve-item']['height'] = radius + 'px';

    this.class['text__curve']['height'] = (radius * 2) + 'px';
    this.class['text__curve']['width'] = (radius * 2) + 'px';
  }

  // GRADIENT
  /**
   * Cập nhật Gradient
   */
  handleSetGradientText() {
    if (this.config['background-image']['gradient_check']) {
      this.class['text__content']['background-image'] = `linear-gradient(${this.config['background-image']['background_image_direction']} ${this.config['background-image']['background_image_arr_gradient']})`;
      this.class['text__content']['-webkit-text-fill-color'] = 'transparent';
      this.class['text__content']['-webkit-background-clip'] = 'text';
    }
    else {
      this.class['text__content']['background-image'] = 'none';
      this.class['text__content']['-webkit-text-fill-color'] = 'unset';
      this.class['text__content']['-webkit-background-clip'] = 'unset';
    }

    // gradient cho kiểu uốn cong
    if (this.config['curve']['isCurve']) {
      this.class['text__curve-item']['background-image'] = this.class['text__content']['background-image'];
      this.class['text__curve-item']['-webkit-text-fill-color'] = this.class['text__content']['-webkit-text-fill-color'];
      this.class['text__curve-item']['-webkit-background-clip'] = this.class['text__content']['-webkit-background-clip'];
    }

    this.updateClass();
    this.updateConfig();
  }

  openbgGradient() {
    if (isPlatformBrowser(this.platformId)) document.getElementById('input-gradient').click();
  }
  /** Hàm này cho phép chọn options direction của màu gradient
   * @param direction : trả về hướng phối màu được chọn
   * @param event : trả về element được active
   */
  chooseOption(direction, event) {
    this.config['background-image']['background_image_direction'] = direction.direction;
    this.handleSetGradientText();
  }
  /** Chuyển đổi mã màu hexadecimal thành mã màu rgba.
   * @param hex : tham số trả về mã màu hex
   * @returns string : trả về chuỗi rgb
   */
  hexToRGB(hex: string): string {
    // Loại bỏ ký tự '#' từ mã hex
    hex = hex.replace('#', '');

    // Tách mã hex thành các thành phần màu
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);

    // Trả về giá trị RGB
    return `${r}, ${g}, ${b}`;
  }
  /** Xử lý lấy thông số giá trị background gradient
   * @param event : trả về giá trị từ 0-100
   */
  getValueRangeBackgroundGradient(e) {
    this.config['background-image']['background_image_opacity'] = e.target.value;
    const newArr = this.config['background-image']['background_image_arr_gradient'].map((color) => {
      const parts = color.match(/(\d+(\.\d+)?)/g); // Tách các phần tử màu từ chuỗi rgba
      return `rgba(${parts[0]}, ${parts[1]}, ${parts[2]}, ${this.config['background-image']['background_image_opacity'] / 100})`;
    });
    this.config['background-image']['background_image_arr_gradient'] = newArr;

    this.handleSetGradientText();
  }
  /**
  * Hàm này thực hiện thêm màu gradient vào array.
  *
  */
  addGradient() {
    this.config['background-image']['background_image_arr_gradient'].push(
      `rgba(${this.hexToRGB(this.config['background-image']['background_image_background_color'])}, ${this.config['background-image']['background_image_opacity'] / 100})`
    );
    this.handleSetGradientText();
  }
  /**  Hàm này cho phép xóa phần tử màu gradient trong array bằng index của phần tử đó.
  * @param index : vị trí phần tử muốn xóa
  */
  deleteGradient(index) {
    this.config['background-image']['background_image_arr_gradient'].splice(index, 1);
    this.handleSetGradientText();
  }

  /**
   * Hàm update object vào database.
   */
  updateObject() {
    return this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class, [this.device + '_config']: this.config, staticdata: this.staticdata })
      .then((bool: any) => {

      });
  }

  /**
   * Hàm update class
   */
  updateClass() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_class']: this.class })
      .then((bool: any) => {

      });
  }

  /**
   * Hàm update config
   */
  updateConfig() {
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, { [this.device + '_config']: this.config })
      .then((bool: any) => {

      });
  }


  /**
   * Set biểu tượng con trỏ chuột mặc định cho dạng có link
   */
  handleChangeLink() {
    if ((this.staticdata.link != null || this.staticdata.hyper_link) && this.class['text']['cursor'] == 'default') {
      this.class['text']['cursor'] = 'pointer';
      this.updateClass();
    }
  }

  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   * @param: value
   */
  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }
  openMap: { [name: string]: boolean; } = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false,
    menu8: false,
  };



  /**
   * Hàm này set customize mở mở phần mở rộng của config từ choose-animations-config truyền về
   * @param event customize sau khi thay đổi
   */
  openAnimationDetail(event) {
    this.customize = event;
    if (this.config['animation-selected'].id != '000000') {
      this.openViewAll(this.styles_field[0]);
    }
  }
  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi
   */
  changeWidthHeight(event) {
    if (event.width) this.class['text']['width'] = event.width + 'px';
    if (event.height) this.class['text']['height'] = event.height + 'px';
    this.vhEventMediator.notifyOnConfigChanged({ status: 'update-object-selected-ruler', code: this.objectChoosing._id });
    this.updateClass();
  }

  /**
  * Lấy danh sách các input dạng "input-calculate-custom" từ server.
  * Nếu component hiện tại không phải 'AtwTextCalculateCustom' thì bỏ qua.
  * Sau khi lấy dữ liệu, hiển thị công thức với tên thay vì ID.
  */
  getObjectForCalculate() {
    if (this.objectChoosing.component != 'AtwTextCalculateCustom') return;

    this.vhQueryAutoWeb.getObjects_byFields({ type: { $eq: 'input-calculate-custom' } }, {}, {}, 0)
      .then((objects) => {
        this.inputCalculateCustom = objects;
        this.formulaDraft = this.displayFormulaFromId(this.staticdata.formula);
      });
  }

  /**
  * Thêm một biến vào công thức tại vị trí con trỏ hiện tại trong textarea.
  * @param name - Tên của biến (sẽ được chèn vào dưới dạng {{name}})
  */
  insertToFormula(name: string) {
    if (!this.formulaBox) return;

    const textarea = this.formulaBox.nativeElement as HTMLTextAreaElement;
    const start = textarea.selectionStart;
    const end = textarea.selectionEnd;
    const before = this.formulaDraft?.slice(0, start) ?? '';
    const after = this.formulaDraft?.slice(end) ?? '';

    this.formulaDraft = `${before}{{${name}}}${after}`;
  }

  /**
  * Khi người dùng xác nhận công thức: convert tên (name) → ID để lưu vào staticdata.
  * Sau đó gọi hàm cập nhật staticdata.
  */
  confirmFormula() {
    this.staticdata.formula = this.convertNameToId(this.formulaDraft);
    this.updateStaticData();
  }

  /**
  * Chuyển công thức chứa ID sang công thức hiển thị chứa tên.
  * Ví dụ: {{abc123}} → {{Chiều cao}}
  * @param formulaWithIds - Công thức chứa ID, ví dụ: "{{abc123}} + {{xyz456}}"
  * @returns Công thức đã thay ID bằng tên tương ứng, ví dụ: "{{Height}} + {{Weight}}"
  */
  displayFormulaFromId(formulaWithIds: string): string {
    if (!formulaWithIds) return '';

    // Đảm bảo danh sách input là mảng
    const inputs = Array.isArray(this.inputCalculateCustom) ? this.inputCalculateCustom : [];

    return formulaWithIds.replace(/{{(.*?)}}/g, (_match, id) => {
      const input = inputs.find(i => i._id === id);
      return input ? `{{${input.name}}}` : `{{${id}}}`;
    });
  }

  /**
  * Chuyển công thức từ tên biến (name) sang ID để lưu trữ.
  * Ví dụ: {{Chiều cao}} → {{abc123}}
  * @param formulaWithNames - Công thức chứa tên biến
  * @returns Công thức đã thay tên bằng ID tương ứng
  */
  convertNameToId(formulaWithNames: string): string {
    return formulaWithNames.replace(/{{(.*?)}}/g, (_match, name) => {
      const input = this.inputCalculateCustom.find(i => i.name === name);
      return input ? `{{${input._id}}}` : `{{${name}}}`;
    });
  }

  /**
   * Update nội dung 
   * @example
   * data = [ { langCode: 'vi', translatedText: 'Bản đồ Việt Nam' } ]
   */
  updateContent() {
    if (this.objectChoosing.setup?.auto_translate_language?.enable) {
      this.functionService.translateToMultipleLanguages(
        this.staticdata['content_' + this.functionService.selectedLanguageCode]
      )
      .subscribe({
        next: (data) => {
          // console.log('data', data)
          this.functionService.multi_languages.forEach(lang => {
            if (
              this.functionService.selectedLanguageCode != lang.code 
              && !this.staticdata['content_' + lang.code]
            ) {
              this.staticdata['content_' + lang.code] = data.find(
                item => item.langCode == lang.code
              ).translatedText;
            }
          });
          this.updateStaticData();
        },
        error: (err) => {
          console.error('Lỗi dịch thuật:', err);
        }
      });
    } else {
      this.updateStaticData();
    }
  }
}
